import { render, staticRenderFns } from "./FilterAccordion.vue?vue&type=template&id=16b45f95&scoped=true&"
import script from "./FilterAccordion.vue?vue&type=script&lang=js&"
export * from "./FilterAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FilterAccordion.vue?vue&type=style&index=0&id=16b45f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b45f95",
  null
  
)

export default component.exports